import { useSearchParams } from 'react-router-dom';

import { SUPPLIER_CERTIFICATES_TABLE_PAGE_SIZE } from '../shared/constants/certificates.constant';
import { parseString } from '../shared/helpers/url-parameter-parser';
import { GetSupplierCertificatesParams } from './api/certificates';

type SupplierCertificatesTableQueryState = {
  skip: number;
  size: number;
  sort: string | undefined;
  filters: Partial<GetSupplierCertificatesParams>;
  setParams: (params: Record<string, string | number | string[] | undefined>) => void;
};

export const DEFAULT_SORT = 'received-desc';

export const useSupplierCertificatesTableQueryParams = (): SupplierCertificatesTableQueryState => {
  const [sp, setSp] = useSearchParams();

  const skip =
    (Number(sp.get('page') ?? 1) - 1) *
    Number(sp.get('size') ?? SUPPLIER_CERTIFICATES_TABLE_PAGE_SIZE);
  const size = Number(sp.get('size') ?? SUPPLIER_CERTIFICATES_TABLE_PAGE_SIZE);

  const sort = sp.get('sort') ?? DEFAULT_SORT;

  const filters: Partial<GetSupplierCertificatesParams> = {
    reviewStatus: parseString(sp.get('reviewStatus')) || undefined,
  };

  const setParams = (params: Record<string, string | number | string[] | undefined>): void => {
    const next = new URLSearchParams(sp);

    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || (Array.isArray(value) && value.length === 0) || value === '') {
        next.delete(key);

        return;
      }

      if (Array.isArray(value)) {
        next.set(key, value.join(','));

        return;
      }

      next.set(key, String(value));
    });

    setSp(next, { replace: true });
  };

  return {
    skip,
    size,
    sort,
    filters,
    setParams,
  };
};
